import React from 'react';
import { useTranslation } from 'react-i18next';

import './MapSection.css';

const MapSection = () => {
  const { t } = useTranslation();
  return (
    <div className='map-section' style={{ width: '100%', height: 'auto', minHeight: '450px' }}>
      <h2>{t('map.title', '📍 Localisation de la villa')}</h2>
      <div className='trajets-section'>
        <div className="trajet-highlight">
          <span className="icon">🛫</span>
          <span className="text">{t('map.toAirport', "25 min de l'aéroport d'Olbia.")}</span>
        </div>
        <div className="trajet-highlight">
          <span className="icon">🏖️</span>
          <span className="text">{t('map.toSanTeodoro', "9 min de San Teodoro.")}</span>
        </div>
        <div className="trajet-highlight">
          <span className="icon">🏝️</span>
          <span className="text">{t('map.toBudoni', "8 min de Budoni.")}</span>
        </div>
      </div>

      <iframe
        title="Villa Location Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1433.3698168644858!2d9.64437986347688!3d40.723544755822566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12decf50f3a2c505%3A0x96986a772c0e6c8c!2s07052%20Franculacciu%20Sassari%2C%20Italie!5e1!3m2!1sfr!2sfr!4v1753803396465!5m2!1sfr!2sfr"
        width="100%"
        height="450px"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default MapSection;
